import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // 导入路由配置

// 引入 Vuetify 相关的模块
import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // 引入 Vuetify 样式
import '@mdi/font/css/materialdesignicons.css'; // 可选：引入 Material Design Icons 图标
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// 引入 FontAwesome 相关模块
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUsers, faLanguage, faUserAlt, faSchool, faLayerGroup, faBalanceScale, faProjectDiagram, faPencilAlt, faBook, faImage, faRobot, faChartLine, faMusic, faPlay, faUserGraduate, faVideo, faSearch, faLaptopCode, faChalkboardTeacher,faHome, faPhone, faEnvelope, faFileAlt,faChevronUp, faChevronDown, faFilm} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// 将需要的图标添加到库中
library.add( faUsers, faLanguage, faUserAlt, faSchool, faLayerGroup, faBalanceScale,faProjectDiagram, faPencilAlt, faBook, faImage, faRobot, faChartLine, faMusic, faPlay, faUserGraduate,faVideo, faSearch, faLaptopCode, faChalkboardTeacher,faHome, faPhone, faEnvelope, faFileAlt,faChevronUp, faChevronDown,faFilm );

// 创建 Vuetify 实例
const vuetify = createVuetify({
  components,
  directives,
});

createApp(App)
  .use(router) // 使用 Vue Router
  .use(vuetify) // 使用 Vuetify
  .component('font-awesome-icon', FontAwesomeIcon) // 注册 FontAwesome 组件
  .mount('#app');
